import posthog from 'posthog-js';

import { isPostHogEnabled } from './isPostHogEnabled';

/**
 * Update OpsPilot properties on the `organization` PostHog group. Merges with
 * existing group properties. Always pass the current organization id so state
 * stays isolated per org.
 */
export const setOpsPilotOrgProperties = (
  organizationId: string,
  properties: Record<string, unknown>
) => {
  if (!isPostHogEnabled) {
    return;
  }
  posthog.group('organization', organizationId, properties);
};

/** Set OpsPilot properties on the current (person-level) PostHog profile. */
export const setOpsPilotUserProperties = (
  properties: Record<string, unknown>
) => {
  if (!isPostHogEnabled) {
    return;
  }
  posthog.setPersonProperties(properties);
};
